'use client';

import {
    Column,
    Columns,
    Icon,
    IconName,
    IconSize,
    Justifiable,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TypographyAlign,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

const content = [
    {
        title: 'Une installation rapide et gratuite',
        content:
            "Choisissez un RDV qui vous arrange, on s'occupe du reste ! Tout est gratuit : la livraison de la box en point relais, le raccordement à la fibre...",
        iconName: IconName.V_SIGN,
    },
    {
        title: 'Vos frais de résiliation remboursés',
        content:
            'Votre opérateur internet vous demande des frais pour résilier votre box actuelle ? On vous les rembourse à hauteur de 50€ sur simple demande.',
        iconName: IconName.GIFT,
    },
    {
        title: "Une assistance 7j/7 via l'appli",
        content:
            'Un problème ? Pas de problème ! Ouvrez votre application Bouygues Telecom, et accédez à une assistance disponible 24h/24 et par téléphone les 2 premiers mois.',
        iconName: IconName.HAND_MOBILE,
    },
];

export function ByouReinsurance() {
    return (
        <>
            <Title
                className='has-text-centered has-text-blue-byou'
                typo={TypographyAlign.TEXT_CENTERED}
                level={TitleLevels.TWO}
            >
                Trois raisons de choisir une box B&YOU
            </Title>
            <Columns>
                {content.map((reason) => (
                    <ReasonItem
                        key={reason.title}
                        title={reason.title}
                        content={reason.content}
                        iconName={reason.iconName}
                    />
                ))}
            </Columns>
        </>
    );
}

interface ReasonItemProps {
    iconName: IconName;
    title: string;
    content: string;
}

function ReasonItem({ iconName, title, content }: Readonly<ReasonItemProps>) {
    return (
        <Column>
            <View flexable justify={Justifiable.JUSTIFIED_CENTER}>
                <Icon name={iconName} size={IconSize.LARGE} />
            </View>
            <Text
                typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                className='has-text-centered-mobile'
                level={TextLevels.ONE}
            >
                {title}
            </Text>
            <Text className='has-text-centered-mobile' level={TextLevels.TWO}>
                {content}
            </Text>
        </Column>
    );
}
